<table class="radio-table">
  <thead>
    <tr>
      <th class="question-header">{{ label }}</th>
      <th class="option-header" *ngFor="let option of options">
        {{ option.label }}
      </th>
    </tr>
  </thead>
  <tbody>
    <tr *ngFor="let field of fields">
      <td class="question-cell">{{ field.label }}</td>
      <td class="option-cell" *ngFor="let option of options" [class.selected]="isChecked(field, option)">
        <mat-radio-group
          [name]="field.label"
          [value]="getQuestionValue(field)"
          (change)="valueChanged($event, field)"
        >
          <mat-radio-button
            [value]="option.value"
            [disabled]="readonly"
            [checked]="isChecked(field, option)"
          >
          </mat-radio-button>
        </mat-radio-group>
      </td>
    </tr>
  </tbody>
</table>
